import { render } from "./generalInformation.vue?vue&type=template&id=23a9d030&scoped=true"
import script from "./generalInformation.vue?vue&type=script&lang=js"
export * from "./generalInformation.vue?vue&type=script&lang=js"

import "./generalInformation.vue?vue&type=style&index=0&id=23a9d030&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23a9d030"]])

export default __exports__